import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import ModalHeadAndClose from '../common/ModalHeadAndClose';
import CreateNewSettlement from '../settlemet/CreateNewSettlement';
import CreateNewCTO from '../cto/CreateNewCTO';

function SettlementCtoModal({ onClose }) {
    return (
        <div className="outerContainer">
            <div className="addCtoHeadContainer settlementCtoModalContainer">
                <ModalHeadAndClose
                    title=""
                    onClose={onClose}
                />

                <div className="tabsCtoContainer">
                    <Tabs
                        defaultActiveKey="settlement"
                        id="uncontrolled-cto-tab"
                        className=""
                    >
                        <Tab eventKey="settlement" title="Settlement">
                            <CreateNewSettlement />
                        </Tab>
                        <Tab eventKey="cto" title="CTO">
                            <CreateNewCTO />
                        </Tab>
                    </Tabs>
                </div>
            </div>
        </div>
    )
}

export default SettlementCtoModal;